// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LiveChat: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 52 42"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fillRule="evenodd"
                d="M43.929 12.612c4.865 2.324 8.07 6.213 8.07 10.631 0 4.005-2.627 7.595-6.756 9.966L52 42l-15.496-6.007.046-.022a23.675 23.675 0 01-3.16.207c-5.949 0-11.23-1.933-14.619-4.971.669.069 1.383.091 2.121.091 12.776 0 23.176-7.547 23.176-16.822 0-.645-.047-1.266-.14-1.864zM20.892 0c2.168 0 4.244.23 6.203.644 1.315.3 2.56.667 3.736 1.104 1.776.669 3.413 1.497 4.82 2.486 2.859 1.98 4.888 4.51 5.696 7.365.276.92.414 1.887.414 2.877 0 8.008-9.34 14.499-20.869 14.499-1.222 0-2.397-.047-3.55-.208l.045.023-.623.23-16.74 6.49 7.562-9.85C2.952 23.015 0 18.988 0 14.477 0 10.47 2.329 6.858 6.11 4.234a23.236 23.236 0 014.82-2.486A29.917 29.917 0 0114.689.644 30.01 30.01 0 0120.892 0z"
            />
        </svg>
    );
};

export default React.memo(LiveChat);
